import React, { useEffect, useRef, useState } from "react";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import NetaqInput from "../components/NetaqInput";
import Select from "react-select";
import ActionButton from "../components/ActionButton";
import { useLocation, useNavigate } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import {
    FetchCreateOrEditRequestSemenCertificatethunk,
    FetchGetServiceDefinitionByIdthunk,
    FetchGetServicesRequestByIdthunk,
} from "../Redux/ServicesRequests/ServicesRequestsAction";
import {
    resetGetServicesRequestByIdData,
    resetToasterMessageServicesRequests,
} from "../Redux/ServicesRequests/ServicesRequestsSlice";
import { FetchSubOwnerProfilesByIdthunk } from "../Redux/ShowEntry/ShowEntryAction";
import EahsForm from "../components/EahsForm";
import { FetchOwnerHorsesDropDownthunk } from "../Redux/OwnerProfile/OwnerProfileAction";
import { isLessThanUndefinedYearOld } from "../helper/isLessThanUndefinedYearOld";
import PillBtn from "../components/PillBtn";
import DraftBtn from "../components/servicesButtons/DraftBtn";
import ApproveAndPayLaterBtn from "../components/servicesButtons/ApproveAndPayLaterBtn";
import SubmitAndPay from "../components/servicesButtons/SubmitAndPay";
import SubmitServiceBtn from "../components/servicesButtons/SubmitServiceBtn";
import { eFormButtonsContainer, eformInput, eformTerms, serviceRequestHeadContainer, serviceRequestTitle, userDropDown } from "../common/cssclasses";
import { geteligiblestallions } from "./sharedAPI/lookUpApis";
import { formatDate } from "../helper/formatDate";

export default function RequestSemenCertificate() {
    //env
    const UMBRACOURL = process.env.REACT_APP_UMBRACO;
    //const UMBRACOURL = process.env.REACT_APP_Local_UMBRACO;
    const BaseURL = process.env.REACT_APP_BASE_URL;

    //selector
    const { ownerHorsesDropDownData } = useSelector(
        (state) => state.ownerProfileSlice
    );

    const { currentLanguage } = useSelector((state) => state.studBookSlice);

    const {
        toasterMessageServicesRequests,
        servicesRequestsLoading,
        getServicesRequestByIdData,
        getServiceDefinitionByIdData,
        requestSemenCertificateData,
    } = useSelector((state) => state.servicesRequestsSlice);

    const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));
    const subOwnerProfilesByIdData = userProfile?.subAccounts ?? [];

    const dispatch = useDispatch();

    const { translate } = useTranslate();

    const navigate = useNavigate();

    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);

    const serviceId = searchParams.has("serviceId")
        ? searchParams.get("serviceId")
        : null;

    const id = searchParams.has("id") ? searchParams.get("id") : null;

    const action = searchParams.has("action") ? searchParams.get("action") : null;
    const ownerId = searchParams.has("ownerId") ? searchParams.get("ownerId") : null;


    //state
    const [profile, setProfile] = useState({
        label:
            !!userProfile &&
            userProfile?.ownerRegisterNo +
            " - " +
            userProfile[`fullName${currentLanguage === "en" ? "" : "Ar"}`],
        value: localStorage.getItem("EAHSUserID"),
    });

    const [collectionDate, setCollectionDate] = useState('');
    const [horseOptions, setHorseOptions] = useState([]);

    const [formModel, setFormModel] = useState({
        id: null,
        eventName: "",
        comment: "",
        referenceNumber: "",
        requestsType: "",
        paymentStatus: "",

        horse: "",
        horseDrop: {
            label: translate("web.horse", "Horse"),
            value: null,
        },

        numberOfDoses: 0,

        ownerComment: "",
    });

    const [errorHorse, setErrorHorse] = useState(false);
    const [errorNumberOfSemenDoses, setErrorNumberOfSemenDoses] = useState(false);

    //use ref
    const horseRef = useRef(null);
    const numberOfSemenDosesRef = useRef(null);

    const _isOnlinePayment = useRef("");
    const _status = useRef("");

    const [checkedItems, setCheckedItems] = useState({});

    // const [checkedItems, setCheckedItems] = useState({
    //     option1: false,
    // });

    const subAccountId = localStorage.getItem("currentSubAccountId");

    const customStyles = {
        control: (base) => ({
            ...base,
            height: 50,
            minHeight: 50,
        }),
    };

    //function   

    const handleFormChange = (e, input) => {
        if (input === "horse") {
            setFormModel({
                ...formModel,
                horse: e.value,
                horseDrop: e,
            });
        }
        else {
            setFormModel({
                ...formModel,
                [e.target.name]: e.target.value,
            });
        }
    };

    const validInputs = () => {
        let valid = true;

        if (formModel.horse === "") {
            setErrorHorse(true);
            valid = false;

            horseRef?.current?.focus();
            return;
        }
        else {
            setErrorHorse(false);
        }

        if (formModel.numberOfDoses === "" || Number(formModel.numberOfDoses) < 1) {
            setErrorNumberOfSemenDoses(true);
            valid = false;

            numberOfSemenDosesRef?.current?.focus();
            return;
        }
        else {
            setErrorNumberOfSemenDoses(false);
        }

        //term
        if (Object.values(checkedItems).length > 0) {  // Optional safe check
            const allTermsChecked = Object.values(checkedItems).every((isChecked) => isChecked);

            if (!allTermsChecked && action == null) {
                toast.error(
                    translate("web.pleaseCheckAllTerms", "Please Check All Terms")
                );
                valid = false;
            }
        }

        // if (
        //     !checkedItems.option1
        // ) {
        //     toast.error(
        //         translate("web.pleaseCheckTerm", "Please Check Term")
        //     );
        //     valid = false;
        // }

        return valid;
    }

    const handelFormSubmit = (status, isOnlinePayment, buttonAction = 'Draft') => {
        if (getServiceDefinitionByIdData.serviceFees > 0 && formModel.eventName === "PendingPayment") {
            const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${id}`;

            const encodeURI = encodeURIComponent(returnUrl);

            window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${id}&paymentType=24&userId=${localStorage.getItem("EAHSUserID")}&returnUrl=${encodeURI}&isOnline=${isOnlinePayment}&lang=${currentLanguage}`;
        }
        else {
            if (
                validInputs()
            ) {
                _isOnlinePayment.current = isOnlinePayment;
                _status.current = status;

                let params = {
                    id: id,
                    ownerId: getUserID(),
                    status: status,
                    horse: formModel.horse,
                    numberOfDoses: formModel.numberOfDoses,
                    ownerComment: formModel.ownerComment,
                    buttonAction: buttonAction,
                    searchDate: formatDate(collectionDate, true, true)
                };

                dispatch(FetchCreateOrEditRequestSemenCertificatethunk(params));
            }
            else {
                toast.error(
                    translate("web.completeTheRequiredData", "Complete The Required Data")
                );
            }
        }
    };

    const handelSelectedAccountChange = async (element) => {
        let params = {
            ownerId: element.value,
            skip: 0,
            take: 1000,
            langauge: currentLanguage,
            horseTypeFilter: "1",
            searchValue: "",
            sortBy: "-1",
            serviceDefinitionId: serviceId,
        };
        dispatch(FetchOwnerHorsesDropDownthunk(params));

        setProfile(element);
        setFormModel({
            ...formModel,
            horse: "",
            horseDrop: {
                label: translate("web.horse", "Horse"),
                value: null,
            },
            numberOfDoses: 0,
        });
    };

    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;

        setCheckedItems((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };

    function CheckIfAgentHasPermission() {
        const AgentHasPermission = userProfile.subAccounts
            .filter((x) => x.value == subAccountId)[0]
            .ownersPermissionsList.some(
                (x) =>
                    x.permissionName === "RequestSemenCertificate" || x.permissionName === "All"
            );

        return AgentHasPermission;
    }

    // const getUserID = () => {
    //     const userID =
    //         !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;

    //     return userID;
    // };
    const getUserID = () => {
    let userID =
      !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
    if ((action == null || action === "edit") == false) {
      userID = subAccountId;
    }
    return userID;
  };

    const getSelectedAccountName = () => {
        const selectAccount = userProfile.subAccounts.filter(
            (x) => x.value == subAccountId
        );

        if (selectAccount.length > 0) {
            return selectAccount[0];
        }
        else {
            return false;
        }
    };

    const dismissAll = () => toast.dismiss();

    const handelDisabledButton = (isNotDate = true) => {

        if (
            action === "view"
            || (action === "approve" && formModel.eventName !== "SentBack")
        ) {
            return true;
        } else if (!collectionDate && isNotDate) {
            return true;
        }
        else {
            return false;
        }
    };

    // collectionDate
    function changeCollectionDate(e) {
        setCollectionDate(e?.target?.value);
        geteligiblestallions(profile?.value, e?.target?.value, serviceId).then(res => {
            setHorseOptions(res);
        })
        setFormModel({
            ...formModel,
            horse: null,
            horseDrop: null,
        });

    }

    //Effect
    useEffect(() => {
        if (id != null) {
            let params = {
                language: currentLanguage,
                id: id,
                ownerId: ownerId,
            };

            dispatch(FetchGetServicesRequestByIdthunk(params));
        }

        return () => {
            dispatch(resetGetServicesRequestByIdData());
        };
    }, []);

    useEffect(() => {
        if (!!userProfile && userProfile?.haveProfileSignture != true) {
            toast.error(
                translate(
                    "web.completeOwnerProfileData",
                    "Please complete the personal data of the profile."
                )
            );

            setTimeout(() => {
                navigate("/profile");
            }, 3000);
        }

        if (!!userProfile && userProfile?.accountType === "Agent") {
            if (userProfile.id == subAccountId) {
                navigate("/403-Not-Authrized");
            }

            if (!CheckIfAgentHasPermission()) {
                navigate("/403-Not-Authrized");
            }
        }

        let params = {
            ownerId: getUserID(),
            skip: 0,
            take: 1000,
            langauge: currentLanguage,
            horseTypeFilter: "1",
            searchValue: "",
            sortBy: "-1",
            serviceDefinitionId: serviceId,
        };
        dispatch(FetchOwnerHorsesDropDownthunk(params));

        let subOwnerProfilesParams = {
            id: getUserID(),
            langauge: currentLanguage,
        };
        dispatch(FetchSubOwnerProfilesByIdthunk(subOwnerProfilesParams));

        dispatch(FetchGetServiceDefinitionByIdthunk(serviceId));
    }, [currentLanguage]);

    useEffect(() => {
        if (getServicesRequestByIdData != null &&
            Object.keys(getServicesRequestByIdData).length > 0 && (getServicesRequestByIdData.serviceDefinitionId == serviceId)
        ) {
            setCollectionDate(formatDate(getServicesRequestByIdData?.requestSemenCertificateDto?.searchDate , false , true))
            setFormModel({
                ...formModel,
                eventName: getServicesRequestByIdData.eventName,
                comment: getServicesRequestByIdData.comment,
                requestsType: getServicesRequestByIdData.requestsType,
                paymentStatus: getServicesRequestByIdData.paymentStatus,
                referenceNumber: " - " + getServicesRequestByIdData.referenceNumber,

                horse: getServicesRequestByIdData.requestSemenCertificateDto.horse,
                horseDrop: {
                    label: getServicesRequestByIdData.requestSemenCertificateDto.horseName,
                    value: getServicesRequestByIdData.requestSemenCertificateDto.horse,
                },
                numberOfDoses: getServicesRequestByIdData.requestSemenCertificateDto.numberOfDoses,
            });

            //another owner
            if (
                getServicesRequestByIdData.requestSemenCertificateDto.ownerId !==
                getServicesRequestByIdData.requestSemenCertificateDto.createdBy &&
                subOwnerProfilesByIdData.length > 0 &&
                getServicesRequestByIdData.requestsType !== "BackOffice"
            ) {
                let params = {
                    ownerId: getServicesRequestByIdData.requestSemenCertificateDto.ownerId,
                    skip: 0,
                    take: 1000,
                    langauge: currentLanguage,
                    horseTypeFilter: "1",
                    searchValue: "",
                    sortBy: "-1",
                    serviceDefinitionId: serviceId,
                };
                dispatch(FetchOwnerHorsesDropDownthunk(params));

                //update profile
                setProfile({
                    label:
                        subOwnerProfilesByIdData.filter(
                            (item) =>
                                item.value ==
                                getServicesRequestByIdData.requestSemenCertificateDto.ownerId
                        )[0].registerNo +
                        " - " +
                        subOwnerProfilesByIdData.filter(
                            (item) =>
                                item.value ==
                                getServicesRequestByIdData.requestSemenCertificateDto.ownerId
                        )[0][`text${currentLanguage === "en" ? "" : "Ar"}`],
                    value: subOwnerProfilesByIdData.filter(
                        (item) =>
                            item.value == getServicesRequestByIdData.requestSemenCertificateDto.ownerId
                    )[0].value,
                });
            }

            //options
            // setCheckedItems({
            //     option1: true,
            // });
        }
    }, [
        getServicesRequestByIdData,
    ]);

    useEffect(() => {
        if (
            toasterMessageServicesRequests != null &&
            toasterMessageServicesRequests === "save"
        ) {
            if (_isOnlinePayment.current !== "") {
                toast.success(
                    translate(
                        "web.yourRequestHasSubmittedSuccessfully",
                        "Your Request Has Submitted Successfully"
                    )
                );
            } else {
                toast.success(
                    translate("web.dataSavedSuccessfully", "Data Saved Successfully")
                );
            }

            dispatch(resetToasterMessageServicesRequests());

            setTimeout(() => {
                if (_isOnlinePayment.current !== "") {
                    const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${requestSemenCertificateData.id}`;

                    const encodeURI = encodeURIComponent(returnUrl);

                    window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${requestSemenCertificateData.id}&paymentType=24&userId=${localStorage.getItem(
                        "EAHSUserID"
                    )}&returnUrl=${encodeURI}&isOnline=${_isOnlinePayment.current}&lang=${currentLanguage}`;
                } else {
                    if (_status.current === "Submit" && formModel.eventName !== "SentBack") {
                        navigate(`/profile?activeTab=${"e_services"}&serviceId=${requestSemenCertificateData.id}`);
                    }
                    else {
                        navigate(`/profile?activeTab=${"e_services"}`);
                    }
                }
            }, 1000);
        }

        //error
        else if (toasterMessageServicesRequests != null && toasterMessageServicesRequests !== "save") {
            if (toasterMessageServicesRequests !== "errorServiceDetails") {

                toast.error(
                    translate(toasterMessageServicesRequests, toasterMessageServicesRequests)
                );

                dispatch(resetToasterMessageServicesRequests());
            }

            else if (toasterMessageServicesRequests === "errorServiceDetails") {
                toast.error(
                    translate("web.createServiceRequestFailed", "Service Request Failed")
                );

                dispatch(resetToasterMessageServicesRequests());

                setTimeout(() => {
                    navigate(`/profile?activeTab=${"e_services"}`);
                }, 1000);
            }
        }
    }, [toasterMessageServicesRequests]);

    useEffect(() => {
        if (getServiceDefinitionByIdData?.termsList) {
            const initialState = {};
            getServiceDefinitionByIdData.termsList.forEach((_, index) => {
                initialState[`option${index + 1}`] = false;
            });
            setCheckedItems(initialState);
        }
    }, [getServiceDefinitionByIdData?.termsList]);

    //consoles
    console.log(formModel)

    return (
        <>
            {/* loading div */}
            <div
                className={`page-overlay text-center ${servicesRequestsLoading
                    ? "classdisplay"
                    : "classnotdisplay"
                    }`}
            >
                <div className="loaderDiv">
                    <Loader />
                </div>
            </div>

            {/* toast */}
            <ToastContainer
                position="top-right"
                onClick={dismissAll}
                theme="colored"
                autoClose={5000}
            />

            {/* content page */}
            <div className={serviceRequestHeadContainer}>

                <h2 className={serviceRequestTitle}>
                    {currentLanguage === "en"
                        ? getServiceDefinitionByIdData.nameEn
                        : getServiceDefinitionByIdData.nameAr} {formModel.referenceNumber}{" "}
                </h2>

                {/* Selected Account */}
                {subOwnerProfilesByIdData.length > 0 &&
                    (action == null || action === "edit") &&
                    (
                        <div className={userDropDown}>
                            {!!userProfile && userProfile?.accountType !== "Agent" ? (
                                <>
                                    <NetaqInput
                                        label={translate("web.selectedAccount", "Selected Account")}
                                        name="selectAccount"
                                        type="select"
                                        listSelect={[
                                            ...(!!subOwnerProfilesByIdData &&
                                                !!subOwnerProfilesByIdData.length > 0 &&
                                                subOwnerProfilesByIdData.map((a) => ({
                                                    label:
                                                        a?.registerNo +
                                                        " - " +
                                                        a[`text${currentLanguage === "en" ? "" : "Ar"}`],
                                                    value: a.value,
                                                }))),
                                        ]}
                                        value={profile}
                                        onChange={(e) => {
                                            handelSelectedAccountChange(e);
                                        }}
                                        placeholder={localStorage.getItem("EAHSUserFullName")}
                                    />
                                </>
                            ) : (
                                <label className="capatalize_text">
                                    {getSelectedAccountName()?.registerNo +
                                        " - " +
                                        getSelectedAccountName()[
                                        `text${currentLanguage === "en" ? "" : "Ar"}`
                                        ]}
                                </label>
                            )}
                        </div>
                    )}
            </div>
            <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.horse", "horse")}>
                <div className={eformInput}>
                    <NetaqInput
                        name={"collectionDate"}
                        key={"collectionDate"}
                        type={"normalDate"}
                        value={collectionDate}
                        label={translate("web.collectionDate", "Collection Date")}
                        onChange={changeCollectionDate}
                        required
                        disabled={handelDisabledButton(false)}
                        maxDate={formatDate(new Date, true, true)}
                    />
                </div>
                <div className={eformInput}>
                    <label>
                        {translate("web.horse", "Horse")}
                        <i className=" colorred"> *</i>
                    </label>
                    <Select
                        options={horseOptions}
                        value={formModel.horseDrop}
                        onChange={(e) => handleFormChange(e, "horse")}
                        placeholder={translate("web.horse", "Horse")}
                        name={"horse"}
                        isSearchable
                        noOptionsMessage={() =>
                            translate("web.noOptions", "No Options")
                        }
                        autoFocus={true}
                        key={"horse"}
                        ref={horseRef}
                        isDisabled={handelDisabledButton()}
                    />
                    {errorHorse && (
                        <p style={{ color: "red" }}>
                            {translate("web.requiredField", "Required Field")}
                        </p>
                    )}
                </div>

                <div className={eformInput}>
                    <NetaqInput
                        name={"numberOfDoses"}
                        key={"numberOfDoses"}
                        type={"numberService"}
                        value={formModel.numberOfDoses}
                        minValue={1}
                        label={translate("web.numberOfDoses", "Number Of Doses")}
                        onChange={handleFormChange}
                        disabled={handelDisabledButton()}
                        required
                        ref={numberOfSemenDosesRef}
                    />
                    {errorNumberOfSemenDoses && (
                        <span style={{ color: "red" }}>
                            {translate("web.requiredField", "Required Field")}
                        </span>
                    )}
                </div>
            </EahsForm>

            {/* Comments */}
            {(!!formModel.comment || !!formModel.ownerComment) && (
                <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.comments", "Comments")}>
                    {!!formModel.comment && (
                        // eahs Comment
                        <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.eahsComments", "EAHS Comments")}
                                name={"adminComment"}
                                type={"textarea"}
                                maxchars={1150}
                                value={formModel.comment}
                                disabled={true}
                            />
                        </div>
                    )}

                    {(!!formModel.ownerComment || formModel.eventName === "SentBack") && (
                        // owner Comment
                        <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.ownerComment", "Owner Comment")}
                                name={"ownerComment"}
                                type={"textarea"}
                                maxchars={1150}
                                value={formModel.ownerComment}
                                onChange={handleFormChange}
                                disabled={formModel.eventName !== "SentBack" ? true : false}
                            />
                        </div>
                    )}
                </EahsForm>
            )}

            <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
                {getServiceDefinitionByIdData?.termsList?.map((item, index) => {
                    return (
                        <div className={eformTerms} key={index}>
                            <NetaqInput
                                type={"checkbox"}
                                label={item}
                                name={`option${index + 1}`}
                                checked={checkedItems[`option${index + 1}`] || action != null}
                                onChange={handleCheckboxChange}
                                disabled={formModel.eventName !== ""}
                            />
                        </div>
                    );
                })}
            </EahsForm>

            {/* <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
                <div className={eformTerms}>
                    <NetaqInput
                        type={"checkbox"}
                        label={translate(
                            "web.ServiceGeneralNote",
                            "Service General Note"
                        )}
                        name="option1"
                        checked={checkedItems.option1}
                        onChange={handleCheckboxChange}
                        disabled={formModel.eventName === "" ? false : true}
                    />
                </div>
            </EahsForm> */}

            {/* buttons*/}
            <div className={eFormButtonsContainer}>
                {/* draft btn */}
                {(formModel.eventName === "" || formModel.eventName === "Draft") && (
                    <DraftBtn
                        onClick={() => handelFormSubmit("Draft", "", "Draft")}
                    />
                )}

                {/* pay btn */}
                {userProfile?.participateWithoutPayment === true && formModel.eventName !== "SentBack" && action !== "view" && getServiceDefinitionByIdData.serviceFees > 0 && (
                    <ApproveAndPayLaterBtn
                        selectedAccountId={profile?.value}
                        onClick={() =>
                            handelFormSubmit("Draft", "no", "Pay")
                        }
                    />
                )}

                {formModel.eventName !== "SentBack" && action !== "view" && getServiceDefinitionByIdData.serviceFees > 0 && (
                    <SubmitAndPay
                        selectedAccountId={profile?.value}
                        onClick={() =>
                            handelFormSubmit("Draft", "yes", "Pay")
                        }
                    />
                )}

                {/* submit btn */}
                {((getServiceDefinitionByIdData.serviceFees === 0 || formModel.eventName === "SentBack") && action !== "view") && (
                    <SubmitServiceBtn
                        onClick={() =>
                            handelFormSubmit("Submit", "", "Submit")
                        }
                        isDisabled={
                            getServiceDefinitionByIdData.serviceFees === 0 || formModel.eventName === "SentBack"
                                ? false
                                : true
                        }
                    />
                )}
            </div>
        </>
    );
}